import { Injector, Injectable } from '@angular/core';
import { Overlay, ComponentType, BlockScrollStrategy } from '@angular/cdk/overlay';
import { DialogRef } from './DialogRef';
import { ComponentPortal } from '@angular/cdk/portal';
import { BW_DIALOG_DATA } from './DialogToken';


export interface DialogConfig {
	data?: any;
}
  

@Injectable({ providedIn: 'root' })
export class DialogService {
	constructor(private overlay: Overlay,
		private injector: Injector) {

	 }

	open<T>(component: ComponentType<T>, config?: DialogConfig) {
		// Globally centered position strategy
		const positionStrategy = this.overlay
			.position()
			.global()
			.centerHorizontally()
			.centerVertically();
			
		const overlayRef = this.overlay.create({
			positionStrategy,
			hasBackdrop: true,
			//scrollStrategy : this.overlay.scrollStrategies.block(),
			//backdropClass: 'overlay-backdrop',
			//panelClass: 'overlay-panel'
		});


		const dialogRef = new DialogRef(overlayRef);

		const injector = Injector.create({
			parent: this.injector,
			providers: [{ provide: DialogRef, useValue: dialogRef },
				{ provide: BW_DIALOG_DATA, useValue: config?.data }]
		});	  
		
		const portal = new ComponentPortal(component, null, injector);
		overlayRef.attach(portal)
		return dialogRef;
	}
	
}